import { object, string, number, array } from 'yup';
import type { AssetID, EventID, TeamID } from '@common/ids';
import { convertSnakeCaseIntoCamelCase, makeEnumSchema, makeUUIDSchema } from './helper';

const AudienceTypeSchema = makeEnumSchema(['players_family', 'players_family_fans'] as const);
const TeamIDSchema = makeUUIDSchema<TeamID>();
const EventIDSchema = makeUUIDSchema<EventID>();
const AssetIDSchema = makeUUIDSchema<AssetID>();

export const streamAssetMetadataWithTimeStampsSchema = object({
    teamID: TeamIDSchema.required(),
    scheduleEventID: EventIDSchema.required(),
    id: AssetIDSchema.required(),
    streamID: string().required(),
    createdAt: string(),
    updatedAt: string(),
    //optional fields
    audienceType: AudienceTypeSchema.nullable(),
    thumbnailUrl: string().nullable(),
    duration: number().nullable(),
    endedAt: string().nullable(),
    playbackUrl: string().nullable(),
    resolutionHeight: number().nullable(),
    resolutionWidth: number().nullable(),
    userID: string().nullable(),
}).transformKeys(convertSnakeCaseIntoCamelCase);

export const streamAssetMetadataWithTimeStampsListSchema = array(streamAssetMetadataWithTimeStampsSchema).required();
